import isArray from 'lodash/isArray'
import isEmpty from 'lodash/isEmpty'

let customValidation = {
    methods: {
        customAutocompleteRequireValidation(value, name, message) {
            const field = this.$validator.fields.find({name});
            if (!field) {
                throw `Field "${name}" in "${this.$options._componentTag}" component don't have validation on client side!`;
            }
            if (isArray(value) && isEmpty(value)) {
                this.$validator.errors.add({
                    id: field.id,
                    field: field.name,
                    msg: this.$validator.dictionary.getMessage(this.$i18n.locale, message.rule, message.data)
                });

                field.setFlags({
                    invalid: true,
                    valid: false,
                    validated: true
                });
                return false
            } else {
                this.$validator.errors.removeById(field.id);
                field.setFlags({
                    invalid: false,
                    valid: true,
                    validated: true
                });
                return true
            }
        }
    }
}

export default customValidation;
